import { ArrowUpRight, Buildings, Elevator, HouseLine, RoadHorizon } from "@phosphor-icons/react";
import { Link } from "react-router-dom";
import { services } from "@/data/siteContent";

const iconMap = {
  "home-moving": HouseLine,
  "office-moving": Buildings,
  "intercity-moving": RoadHorizon,
  "elevator-moving": Elevator,
};

export default function Services() {
  return (
    <section id="hizmetler" data-testid="services-section" className="bg-[#0A0A0B] px-6 py-24 lg:px-8 lg:py-32">
      <div className="mx-auto max-w-7xl">
        <div data-testid="services-heading-block" className="mb-14 max-w-3xl">
          <p data-testid="services-overline" className="text-xs font-black uppercase tracking-[0.22em] text-orange-500">Hizmetlerimiz</p>
          <h2 data-testid="services-title" className="mt-4 font-heading text-3xl font-black tracking-tight text-white sm:text-4xl">Taşınma sürecini baştan sona sadeleştiriyoruz.</h2>
          <p data-testid="services-description" className="mt-5 text-base leading-relaxed text-slate-400 md:text-lg">Kırıkhan ve Hatay çevresinde ihtiyacınıza göre planlanan, ekipmanlı ve disiplinli nakliyat hizmetleri.</p>
        </div>

        <div data-testid="services-grid" data-stagger-group="service-cards" className="grid grid-cols-1 gap-6 md:grid-cols-2 xl:grid-cols-4">
          {services.map((service) => {
            const Icon = iconMap[service.id];
            return (
              <Link key={service.id} to={`/hizmetler/${service.slug}`} data-stagger-item="service-card" data-testid={`service-card-${service.id}`} className="group relative min-h-[430px] overflow-hidden rounded-2xl border border-white/10 bg-[#121214] transition-[border-color,background-color,transform] duration-500 hover:-translate-y-2 hover:border-orange-500/60 hover:bg-[#1A1A1E]">
                <img data-testid={`service-image-${service.id}`} src={service.image} alt={`Has Kırıkhan Nakliyat ${service.title} hizmeti Kırıkhan Hatay`} loading="lazy" className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
                <div className="absolute inset-0 bg-gradient-to-t from-black via-black/70 to-black/10 transition-colors duration-500 group-hover:bg-orange-950/20" />
                <div className="relative z-10 flex h-full min-h-[430px] flex-col justify-end p-6">
                  <div data-testid={`service-icon-${service.id}`} className="mb-5 grid h-12 w-12 place-items-center rounded-xl bg-orange-500 text-white safe-glow">
                    <Icon size={26} weight="duotone" />
                  </div>
                  <div className="flex items-start justify-between gap-4">
                    <h3 data-testid={`service-title-${service.id}`} className="font-heading text-2xl font-black tracking-tight text-white">{service.title}</h3>
                    <ArrowUpRight data-testid={`service-arrow-${service.id}`} size={22} weight="bold" className="mt-1 shrink-0 text-orange-400" />
                  </div>
                  <p data-testid={`service-description-${service.id}`} className="mt-4 text-sm leading-relaxed text-slate-300">{service.description}</p>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}